import { render, staticRenderFns } from "./LabelCanvas.vue?vue&type=template&id=6a623ef2&scoped=true&"
import script from "./LabelCanvas.vue?vue&type=script&lang=ts&"
export * from "./LabelCanvas.vue?vue&type=script&lang=ts&"
function injectStyles (context) {
  
  var style0 = require("./LabelCanvas.vue?vue&type=style&index=0&id=6a623ef2&scoped=true&lang=scss&")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "6a623ef2",
  null
  ,true
)

export default component.exports